import React, { useEffect, useState } from 'react';
import axios from 'axios';

const SendTestEmail = () => {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null);
    const targetEmail = 'hasmukhkalasariya@gmail.com';

    const sendTestEmail = async () => {
        setLoading(true);
        setStatus(null);
        try {
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
            const res = await axios.get(`${API_BASE_URL}/sendtestemail`);
            setStatus({
                success: true,
                message: res.data.message || `Test email sent successfully to ${targetEmail}`,
                info: res.data.info
            });
        } catch (err) {
            console.error("Test email send failed:", err);
            const errMsg = err.response?.data?.message || err.message || "Failed to send test email.";
            setStatus({
                success: false,
                message: errMsg,
                error: err.response?.data?.error || err.response?.data || err
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        sendTestEmail();
    }, []);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f8fafc',
            fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            padding: '20px'
        }}>
            <div style={{
                maxWidth: '560px',
                width: '100%',
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                padding: '36px',
                boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
                textAlign: 'center'
            }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>
                    {loading ? '⏳' : status?.success ? '✉️' : status?.success === false ? '❌' : '📧'}
                </div>

                <h1 style={{ fontSize: '24px', fontWeight: '700', color: '#0f172a', margin: '0 0 8px 0' }}>
                    Send Test Email
                </h1>
                
                <p style={{ fontSize: '15px', color: '#64748b', margin: '0 0 24px 0' }}>
                    Target Address: <strong style={{ color: '#2563eb' }}>{targetEmail}</strong>
                </p>

                {loading && (
                    <div style={{
                        padding: '16px',
                        backgroundColor: '#eff6ff',
                        color: '#1d4ed8',
                        borderRadius: '10px',
                        fontSize: '14px',
                        fontWeight: '500',
                        marginBottom: '24px'
                    }}>
                        Sending test email to {targetEmail}... Please wait.
                    </div>
                )}

                {status?.success && (
                    <div style={{
                        padding: '16px',
                        backgroundColor: '#f0fdf4',
                        border: '1px solid #bbf7d0',
                        color: '#166534',
                        borderRadius: '10px',
                        fontSize: '14px',
                        marginBottom: '24px',
                        textAlign: 'left'
                    }}>
                        <div style={{ fontWeight: '600', marginBottom: '4px' }}>✅ Success!</div>
                        <div>{status.message}</div>
                        {status.info && (
                            <pre style={{
                                marginTop: '12px',
                                background: '#0f172a',
                                color: '#38bdf8',
                                padding: '12px',
                                borderRadius: '8px',
                                fontSize: '12px',
                                overflowX: 'auto',
                                maxHeight: '250px'
                            }}>
                                {JSON.stringify(status.info, null, 2)}
                            </pre>
                        )}
                    </div>
                )}

                {status?.success === false && (
                    <div style={{
                        padding: '16px',
                        backgroundColor: '#fef2f2',
                        border: '1px solid #fecaca',
                        color: '#991b1b',
                        borderRadius: '10px',
                        fontSize: '14px',
                        marginBottom: '24px',
                        textAlign: 'left'
                    }}>
                        <div style={{ fontWeight: '600', marginBottom: '4px' }}>❌ Failed</div>
                        <div>{status.message}</div>
                        {status.error && (
                            <pre style={{
                                marginTop: '12px',
                                background: '#0f172a',
                                color: '#f87171',
                                padding: '12px',
                                borderRadius: '8px',
                                fontSize: '12px',
                                overflowX: 'auto',
                                maxHeight: '250px'
                            }}>
                                {JSON.stringify(status.error, null, 2)}
                            </pre>
                        )}
                    </div>
                )}

                <button
                    onClick={sendTestEmail}
                    disabled={loading}
                    style={{
                        backgroundColor: loading ? '#94a3b8' : '#ff6b00',
                        color: '#ffffff',
                        border: 'none',
                        padding: '12px 28px',
                        fontSize: '15px',
                        fontWeight: '600',
                        borderRadius: '8px',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 4px 12px rgba(255, 107, 0, 0.25)'
                    }}
                >
                    {loading ? 'Sending...' : 'Send Again'}
                </button>
            </div>
        </div>
    );
};

export default SendTestEmail;
